import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './FilterRowItem.scss'

const FilterRowItem = (props) => {
  let baseClass = ['dropdown', 'section-nav-dropdown', 'FilterRowItem']
  if (props.customClass) {
    baseClass = baseClass.concat(props.customClass)
  }

  const filterRowItemClass = classNames(baseClass, {
    'FilterRowItem--open': props.active,
    'FilterRowItem--has-dropdown': props.hasDropdown
  })

  const itemLabel = props.displayedLabel ? props.displayedLabel : props.label
  const getDropDownOptions = () => {
    const dropdownClass = classNames(
      'FilterDropdownSet',
      {
        'FilterDropdownSet--open': !!props.active
      },
      {
        'FilterDropdownSet--closed': !props.active
      },
      {
        'FilterDropdownSet--scroll': props.value === 'instructors'
      }
    )
    return (
      <div className={dropdownClass}>
        <React.Fragment>
          {props.optionInfo.renderDropdownContent()}
        </React.Fragment>
      </div>
    )
  }

  return (
    <>
      <div className={filterRowItemClass}>
        <button
          onClick={() => {
            props.onClickFilterDropdown(props.value)
          }}
        >
          <div className='FilterRowItem__currentShownTitle'>
            {props.customizeLabelDisplay(itemLabel)}
          </div>
        </button>
      </div>
      {props.optionInfo.renderDropdownContent && getDropDownOptions()}
    </>
  )
}

FilterRowItem.defaultProps = {
  customizeLabelDisplay: (label) => label,
  hasDropdown: true
}

FilterRowItem.propTypes = {
  active: PropTypes.bool,
  customClass: PropTypes.string,
  displayedLabel: PropTypes.string,
  hasDropdown: PropTypes.bool,
  onClickFilterDropdown: PropTypes.func,
  label: PropTypes.string,
  customizeLabelDisplay: PropTypes.func,
  value: PropTypes.string
}

export default FilterRowItem
